import api from '../..'

const destroyManyCertificates = (ids: (string | number)[]) => {
  return api.delete(`administration/multiple_external_course_certificates`, {
    data: { ids },
  })
}

export default destroyManyCertificates
